import * as React from 'react'
import { ReactElement } from 'react'
import { Button, ToastTrigger } from '@fluentui/react-components'
import { bundleIcon, DismissFilled, DismissRegular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'

const DismissIcon = bundleIcon(DismissFilled, DismissRegular)

/**
 * Closes the toast it is rendered in. Goes in the `action` slot of a ToastTitle.
 *
 * ToastTrigger dismisses the surrounding toast by itself, so this needs no id and works the same for a queue
 * toast as for a one-off message.
 */
export default function ToastDismiss(): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <ToastTrigger>
            <Button appearance="transparent" size="small" icon={<DismissIcon />} aria-label={translate('action.close')} />
        </ToastTrigger>
    )
}
